import { useGLTF } from "@react-three/drei"
import { useEffect, useRef } from "react"
import { useKTX2 } from "../../../utils/useKtx"
import * as THREE from 'three'
import { useFrame } from "@react-three/fiber"
import { useActsStore } from "../../../store/useActsStore"

export default function Ovni(props) {


    const { nodes } = useGLTF('./models/02/ovni.glb')
    const base = useKTX2('./textures/02/ovni_basecolor.ktx2')
    const normal = useKTX2('./textures/02/ovni_normal.ktx2')

    const navMat = new THREE.MeshStandardMaterial({
        // map: base,
        normalMap: normal,
        color: '#262731',
        roughness: 0.4,
        metalness: 0.5,
        side: THREE.DoubleSide,
    })

    const genMat = new THREE.MeshStandardMaterial({
        map: base,
        roughness: 0.5,
        metalness: 1,
    })

    const lumMat = new THREE.MeshStandardMaterial({
        emissive: '#FF5E5E',
        emissiveIntensity: 1
    })

    const baseOvni = useRef()

    useFrame(() => {
        const stateActe = useActsStore.getState()
        const id = stateActe.getCurrentActId()
        const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0

    })

    return (
        <group {...props} dispose={null} ref={baseOvni}>
            <group position={[0, 0, 0]} rotation={[-Math.PI / 2, 0, 0]} >
                <group rotation={[Math.PI / 2, 0, 0]}>
                    <group position={[0, 97.744, -0.081]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.bordure.geometry}
                            material={navMat}
                            position={[0, 0, 0.148]}
                        />
                    </group>
                    <group position={[0, 97.744, -0.081]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.lumiere.geometry}
                            material={lumMat}
                            position={[0, 0, -0.147]}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes['lumiere-bordure'].geometry}
                            material={navMat}
                            position={[0, 0, -0.165]}
                        />
                    </group>
                    <group position={[0, 97.744, 0]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.navette.geometry}
                            material={navMat}
                            position={[0.002, 0, -0.413]}
                        />
                    </group>
                </group>
            </group>
        </group>
    )
}